module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLightItalic.cef9cc6.woff";